import { IconButton } from "@mui/material";
import { LargeRegularXMarkIcon } from "@icons/LargeRegularXMarkIcon";

export function WrongAnswerXMark() {
    return (
        <IconButton
            sx={{
                padding: 0,
                width: "24px",
                height: "24px",
                backgroundColor: "var(--community-color-snow-white)",
                "&:hover": {
                    backgroundColor: "var(--community-color-snow-white)",
                },
            }}
        >
            <LargeRegularXMarkIcon
                color="var(--community-color-error-red)"
                width="12px"
                height="12px"
            />
        </IconButton>
    );
}
